import { takeEvery, put } from 'redux-saga/effects';
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import history from '../../../router/browserrouter';
import {store} from "../../store";

export default function* watcherGetOrderDetailsSaga() {
  yield takeEvery('LOAD_ORDER_DETAILS', workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: 'DISPLAY_LOADER', payload: payload });
    yield put({ type: 'CLEAR_CART' });
    var payload = {};
    var formatUrl = `api/SalesTransactionV2/get-orders?transactionReference=${action.payload}`;
    yield request('get', payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: 'SET_ITEM', payload: payload });
    yield put({ type: 'ORDER_ID', payload: payload[0]?.orderId });
    store.dispatch({type:'PERSIST_ITEMS',payload:payload})
    yield put({ type: 'DISPLAY_LOADER', payload: payload });
  } catch (e) {
    console.log(e);
    console.log('product-saga', e);
    console.log('product-saga', e.response);
    yield put({ type: 'LOADING_BUTTON_SPINNER' });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: 'API_ERRORED', payload: e });
    yield put({ type: 'DISPLAY_LOADER', payload: payload });
  }
}
